const BYTES_PER_UNIT = 1024;
const DEFAULT_DECIMALS = 2;

export const filesize = (
  bytes: number,
  decimals = DEFAULT_DECIMALS,
): string => {
  let value = bytes;
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  let i = 0;

  for (i; value > BYTES_PER_UNIT; i++) {
    value /= BYTES_PER_UNIT;
  }

  return `${parseFloat(value.toFixed(decimals))} ${units[i]}`;
};
